import React from 'react'
import { motion } from 'framer-motion'
import AnimateIn, { StaggerContainer, StaggerItem } from '../AnimateIn'
import ReviewCard from './ReviewCom'
import R1 from '../../images/rev1.png'
import R2 from '../../images/rev2.png'
import R3 from '../../images/rev3.png'
import R4 from '../../images/r4.png'
import R5 from '../../images/r5.png'
import R6 from '../../images/r6.png'

const reviews = [
  {
    img: R1,
    quote: "My husband and I decided to hire Ms. Molitor from Kelen Immigration Services and don't regret it. She's totally competent, professional, organized, available and comprehensive about my family needs. She guided us through the best path to get the Canadian permanent residence and we obtained it in the easiest way.",
    name: 'Eli and Leo',
  },
  {
    img: R3,
    quote: "Thanks to Kelen Immigration Services we just got our confirmation of Permanent Residence via Express Entry in less time than we expected. Kerry Molitor made our life easier and the process less stressful, explaining to us very clearly step by step. What I like the most about Kelen Services is their fast response.",
    name: 'Cecilia and Ernesto',
  },
  {
    img: R4,
    quote: "I had an exceptional experience with Kerry as my immigration consultant for my Permanent Residency application. Her in-depth knowledge and attention to detail made the process smooth and stress-free. Kerry was always available to answer questions and went above and beyond in her support. I highly recommend Kerry.",
    name: 'Majid',
  },
  {
    img: R5,
    quote: "It was really great to work with Kerry from the time I applied for my study permit. She is super supportive all the time when I have any doubts. Her knowledge and expertise helped a lot to process our work permits, PR application smoothly. Her service is amazing!",
    name: 'Induni',
  },
  {
    img: R2,
    quote: "I would recommend Kerry Molitor to anyone who has an immigration problem. She is very helpful and responsive. After my PGWP application being unfairly declined because of a technical glitch, Kerry was there to fight for my cause. I got approval in two weeks! Many thanks to you Kerry.",
    name: 'Tatiana',
  },
  {
    img: R6,
    quote: "Kerry's service was outstanding!! She was very knowledgeable and her advice was always accurate and personalized! Today I celebrate getting my PR and a big part of it is Kerry's support! Thank you Kerry!",
    name: 'Sebastián',
  },
]

function Reviews() {
  return (
    <section id="review" className="w-full py-16 px-4 sm:py-20 sm:px-8 md:py-24 md:px-12 lg:py-28 lg:px-[90px] bg-customCyan">
      <div className="max-w-7xl mx-auto">
        <AnimateIn from="up">
          <div className="mb-12 sm:mb-16">
            <h2 className="text-primary-color text-[28px] sm:text-[36px] md:text-[44px] lg:text-[48px] text-center font-[900] mb-4">
              What Clients Say
            </h2>
            <motion.div
              className="mx-auto w-20 sm:w-32 md:w-48 h-1 rounded-full bg-primary-color"
              initial={{ scaleX: 0, originX: 0.5 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
            />
          </div>
        </AnimateIn>

        {/* Grid on mobile/tablet */}
        <StaggerContainer
          className="grid grid-cols-1 sm:grid-cols-2 lg:hidden gap-6 md:gap-8"
          staggerDelay={0.08}
        >
          {reviews.map((review, i) => (
            <StaggerItem key={i} from="up">
              <ReviewCard
                img={review.img}
                con={`"${review.quote}"`}
                name={review.name}
              />
            </StaggerItem>
          ))}
        </StaggerContainer>

        {/* Horizontal slider on large screens */}
        <StaggerContainer
          className="review-slider hidden lg:flex lg:overflow-x-auto lg:gap-8 lg:pb-4 -mx-4 lg:-mx-[90px] px-4 lg:px-[90px] snap-x snap-mandatory scroll-smooth"
          staggerDelay={0.08}
        >
          {reviews.map((review, i) => (
            <StaggerItem
              key={i}
              from="up"
              className="shrink-0 w-[340px] xl:w-[380px] snap-center"
            >
              <ReviewCard
                img={review.img}
                con={`"${review.quote}"`}
                name={review.name}
              />
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  )
}

export default Reviews
